import React, { useCallback, useLayoutEffect, useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CommonToolTip, CstmPagination } from "../../../../components/Common/Common";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { useDeleteDisciplineMutation, useGetDisciplineListQuery, useUpdateDisciplineMutation } from "store/services/disciplines";
import { DISCIPLINES_ADD, DISCIPLINES_EDIT } from "config/paths";
import { successMessageToast } from "helpers/common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { debounce } from "lodash";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { DeleteIcon, EditIcon, PlusCircleIcon, SearchIcon, UnArchiveIcon } from "Assets/icons";
import DebouncedSearch from "components/shared/DebouncedSearch";
import TableHeader from "components/shared/FormComponents/TableHeader";
import ErrorComponent from "components/shared/ErrorComponent";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { useDispatch, useSelector } from "react-redux";
import { disciplinesFilter } from "store/slices/filter";

const DisciplineProfile = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const filter = useSelector(state => state?.filter?.disciplinesFilter);

  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [modalType, setModalType] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [disciplineProfiles, setdisciplineProfiles] = useState([]);
  const { data, isLoading, isError, isFetching } = useGetDisciplineListQuery({ page: currentPage, limit: pageSize, ...filter });
  const [deleteDiscipline, { isLoading: deleteDisciplineLoading }] = useDeleteDisciplineMutation();
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const handleEditItem = (id) => {
    navigate(generatePath(DISCIPLINES_EDIT, { id }));
  }

  const resetFilter = () => {
    dispatch(disciplinesFilter({ search: "", status: "", sort: { column: "id", direction: "desc" } }));
    setCurrentPage(1)
  };


  const handleDeleteDiscipline = async () => {
    try {

      setShowModal(false);

      const list = [...disciplineProfiles];
      const index = disciplineProfiles?.findIndex(x => x.id === currentEntry?.id);
      delete list[index];
      setdisciplineProfiles(list.filter(Boolean));

      let result = await deleteDiscipline(currentEntry?.id);
      if (!result.error) {
        successMessageToast(result?.data?.message);
      }
    } catch (err) {
      console.log("error archiving discipline", err);
    }
  }

  const columns = useMemo(() => {
    return [
      {
        head: "Discipline Name",
        accessor: "name",
        sorter: true,
        isComponent: true,
        component: (item, ind) => (
          <div className="d-flex gap-10 align-items-center">
            <h6 className="m-0 fw-bold themeBlue">{item.name}</h6>
          </div>
        ),
      },
      {
        head: "Action",
        accessor: "",
        isComponent: true,
        component: (item) => (
          <div className="ActnBtn d-flex align-items-center  gap-10">
            <CommonToolTip
              text={"Edit"}
              component={<Button
                onClick={() => handleEditItem(item.id)}
                className="p-0"
                variant="transparent"
                type="button"
              >
                <EditIcon />
              </Button>}
            />
            {item?.is_default == "no" && <CommonToolTip
              text={"Delete"}
              component={<Button
                onClick={() => {
                  setCurrentEntry(item);
                  setModalType("delete")
                  setShowModal(true);
                }}
                className="p-0"
                variant="transparent"
                type="button"
              >
                <DeleteIcon />
              </Button>}
            />}
          </div>
        ),
      },
    ]
  }, []);

  const handleFilterChange = (key) => (value) => {
    dispatch(disciplinesFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  }

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  }

  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to first page when page size changes
  }

  useLayoutEffect(() => {

    if (data?.records) setdisciplineProfiles(data?.records)
  }, [data]);

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDeleteDiscipline}
        type={modalType}
      />
      <section className="ManageDiscriplines position-relative py-4">
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <TableHeader
                hideStatusFilter
                heading={"Discipline Profiles"}
                handleFilterChange={handleFilterChange}
                resetFilter={resetFilter}
                filter={filter}
                searchPlaceholder="Discipline Name"
              >
                <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                  <li className="">
                    <Link
                      to="/manage-disciplines/discipline-profiles/add"
                      className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                    >
                      <span className="icn me-1">
                        <PlusCircleIcon />
                      </span>{" "}
                      Add New Discipline
                    </Link>
                  </li>
                </ul>
              </TableHeader>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <div>
                    {(isFetching || deleteDisciplineLoading) && (
                      <LoadingOverlay />
                    )}
                    <TableLayout data={disciplineProfiles} column={columns} filter={filter} handleSort={handleFilterChange("sort")} />
                  </div>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DisciplineProfile;
